import * as React from "react";
import {observer} from "mobx-react";
import {createRef} from "react";
import {UIState} from "../../data/UIState";
import * as moment from "moment";
import {ButtonAction} from "../widgets/ButtonAction";

@observer
export default class Step5Complete extends React.Component<Props> {

  h1ref;

  constructor(props) {
    super(props);
    this.h1ref = createRef();
  }

  componentDidMount() {
    if(this.h1ref && this.h1ref.current) {
      this.h1ref.current.focus();
    }
  }

  render() {

    return (
      <>
        <div className="signup-head">
          <div className="top-check">
            <i className="material-icons">check</i>
          </div>
          <h1 ref={this.h1ref} style={{textAlign:'center'}} tabIndex={0}>Everything looks good!</h1>

          {UIState.settings.PLATFORM_OPEN
            ?
            <div className={"form-element"}>
              {/*<ButtonAction onClick={this.props.continue} className={"cta-button noselect"}>Continue to the Dashboard</ButtonAction>*/}
              <a className="cta-button noselect" href="#" onClick={this.props.continue} style={{textDecoration:'none'}}>Continue to the Dashboard</a>
            </div>
            :
            <p style={{ fontSize: '22px' }}>
              {`Thank you for setting up your account. Wellness Concepts for 
              ${UIState.settings.COMPANY_NAME} will be available on ${UIState.settings.PLATFORM_OPEN_DATE}. See you then!`}
            </p>
          }
        </div>
      </>
    );
  }
}


interface Props {
  continue:()=>void;
}
